'use client';
import {
  MembershipTokenActions,
  MembershipTokenState,
} from '@/features/membership/shared/types/token.types';
import { create } from 'zustand';
import { redeemMembershipTokens } from '@/features/membership/internal/helper/http/redeem-membership-tokens';
import {
  bustMembershipTokensCache,
  fetchMembershipTokensCached,
} from '@/features/membership/internal/helper/http/fetch-membership-tokens';

const initial: MembershipTokenState = {
  tokenSummary: null,
  initialized: false,
};

export const useMembershipTokenStore = create<MembershipTokenState & MembershipTokenActions>(
  (set, get) => ({
    ...initial,
    fetchTokens: async () => {
      try {
        const userTokens = await fetchMembershipTokensCached();
        set({
          tokenSummary: userTokens,
          initialized: true,
        });
      } catch (err) {
        console.error('Failed to fetch member tokens:', err);
      }
    },
    redeemGameWithTokens: async (gameId: string, locale: string) => {
      const { tokenSummary } = get();
      if (!tokenSummary) {
        throw new Error('not Enough tokens');
      }

      const { orderId } = await redeemMembershipTokens(gameId, locale);
      bustMembershipTokensCache();
      await get().fetchTokens();
      return orderId;
    },
    invalidateTokens: () => {
      set({
        initialized: false,
        tokenSummary: null,
      });
    },
  }),
);
